<template>
  <div class="info">
    <HomePic/>
    <BreadNav/>
    <div class="sub-main">
<!--      <div class="left">-->
<!--        <LeftMenu/>-->
<!--      </div>-->
      <div class="right">
        <ProjectList :col="3" :showTitle="false"></ProjectList>
      </div>
    </div>
  </div>
</template>

<style lang="less">
</style>

<script>
import HomePic from '@/components/style1/HomePic.vue';
import BreadNav from '@/components/style1/BreadNav.vue';
import ProjectList from '@/components/style1/ProjectList.vue';

export default {
  name: 'Info',
  components: {
    HomePic, BreadNav, ProjectList,
  },
};
</script>
